import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { PermissionConst } from 'src/app/core/models/permission-const.model';
import { StatusStageModel } from 'src/app/core/models/status-stage.model';
import { RegistersService } from 'src/app/core/services/registers.service';
import { SessionManagerService } from 'src/app/core/services/session-manager.service';
import { ConfirmationModalComponent } from 'src/app/shared/renderers/components/confirmation-modal/confirmation-modal.component';

@Component({
  selector: 'app-stages-status-form',
  templateUrl: './stages-status-form.component.html',
  styleUrls: ['./stages-status-form.component.scss']
})
export class StagesStatusFormComponent implements OnInit {
  id!: number;
  loadingPage: boolean = true;

  backgroundColorValue?: String = "#FFFFFF";
  fontColorValue?: String = "#000000";

  formGroup = this.fb.group({
    id: [''],
    name: ['', Validators.required],
    order: [0, Validators.required],
    deadline: [''],
    deadline_background_color: [this.backgroundColorValue],
    deadline_font_color: [this.fontColorValue],
    desired_time: [''],
    desired_time_background_color: [this.backgroundColorValue],
    desired_time_font_color: [this.fontColorValue]
  });

  fetchedStage!: StatusStageModel;

  isRegister: boolean = true;

  disabledSalvar: boolean = false;
  disabledRemover: boolean = false;

  submitting: boolean = false;
  submittingRemove: boolean = false;
  removeButton?: String = "Desativar";
  submitButton?: String = "Salvar";

  button: boolean = false;

  constructor(private fb: FormBuilder, private registersService: RegistersService, private router: Router, private activatedRoute: ActivatedRoute, config: NgbModalConfig, private modalService: NgbModal, private sessionManager: SessionManagerService, private toast: ToastrService) {
    config.backdrop = 'static';
    config.keyboard = false;
  }


  ngOnInit(): void {
    this.activatedRoute.params.subscribe((params: any) => {
      this.id = Number(params['id']);
      if(this.id) {
        this.isRegister = false;
      }
    });
    this.initializeForm();
  }

  initializeForm() {
    if(this.id) this.fetchStageExistingData();
    else this.loadingPage = false;
  }

  get canSave() {
    if (this.id) {
      return this.sessionManager.getUserPermission(PermissionConst.add_statusstage);
    } else {
      return this.sessionManager.getUserPermission(PermissionConst.change_statusstage);
    }
  }

  get canRemove() {
    return this.sessionManager.getUserPermission(PermissionConst.remove_statusstage);
  }

  fetchStageExistingData() {
    this.registersService.statusStageGet(this.id).subscribe(response => {
      this.fetchedStage = response;
      if (this.fetchedStage.is_active) {
        this.removeButton = "Desativar";
        this.submitButton = "Salvar";
        this.button = true;
      }
      else {
        this.button = false;
        this.submitButton = "Reativar";
        this.formGroup.disable();
      }
      this.formGroup.patchValue(this.fetchedStage);
      this.loadingPage = false;
    }, (error: HttpErrorResponse) => {
      this.mapErrorResponse(error);
    })
  }

  cancelHandler() {
    this.router.navigate(["/dashboard/registers/stageStatus"]);
  }

  submitHandler() {
    this.submitting = true;
    this.formGroup.markAllAsTouched();
    let stageData = this.formGroup.getRawValue() as StatusStageModel;
    if (this.isRegister) {
      if(this.formGroup.valid) {
        this.stageRegister(stageData);
      } else this.submitting = false;
    } else  {
      this.stageEdit(stageData);
    }
  }

  removeHandler() {
    this.submittingRemove = true;
    const modalRef = this.modalService.open(ConfirmationModalComponent, { centered: true });
    modalRef.componentInstance.text = "Deseja desativar este estágio de status?";
    modalRef.result.then((result: boolean) => {
      if(result == true) {
        this.stageRemove();
      } else this.submittingRemove = false;
    });
  }

  stageRegister(stageData: StatusStageModel) {
    stageData.id = undefined;
    this.registersService.statusStageRegister(stageData).subscribe(response => {
      this.toast.success("Estágio de status criado com sucesso", "Sucesso");
      this.cancelHandler();
    }, (error: HttpErrorResponse) => {
      this.mapErrorResponse(error);
      this.submitting = false;
    });
  }

  stageEdit(stageData: StatusStageModel) {
    stageData.is_active = true;
    this.registersService.statusStageEdit(stageData).subscribe(response => {
      this.toast.success("Estágio de status alterado com sucesso", "Sucesso");
      this.cancelHandler();
    }, (error: HttpErrorResponse) => {
      this.mapErrorResponse(error);
      this.submitting = false;
    });
  }

  stageRemove() {
    this.registersService.statusStageRemove(this.id).subscribe(response => {
      this.toast.success("Estágio de status removido com sucesso", "Sucesso");
      this.cancelHandler();
    }, (error: HttpErrorResponse) => {
      this.mapErrorResponse(error);
      this.submitting = false;
    });
  }

  mapErrorResponse(errorResponse: HttpErrorResponse) {
    if (errorResponse.error["detail"]) {
      this.toast.error(errorResponse.error["detail"], "Erro");
    }
    else {
      this.setFormErrors(errorResponse);
    }
  }

  setFormErrors(errorResponse: HttpErrorResponse) {
    let errNames = [
      "name", "deadline",
      "deadline_background_color", "deadline_font_color",
      "desired_time", "desired_time_background_color", "desired_time_font_color"
    ];
    errNames.forEach(name => {
      if (errorResponse.error[name])
        this.formGroup.get(name)?.setErrors({ response: errorResponse.error[name] });
    });
  }

  canDeactivate(): boolean | Observable<boolean> | Promise<boolean> {
    return true;
  }

}
